export default function table() {
	$('.tablepress').wrap('<div class="tablepress-block__shortcode-inner"></div>');
	initScroll();
}

// Initialize mobile filter scrolling functionality
function initScroll() {
	const $tableWrap = $('.tablepress-block__shortcode-inner');

	if ($tableWrap.length === 0) return;

	$tableWrap.each(function() {
		const $this = $(this);
		let isMobile = $tableWrap.css('padding-top') === '1px' ? true : false;

		// Add grabbable class for touch scrolling on mobile
		if (isMobile) { // Mobile breakpoint
			$this.addClass('--grabbable');

			// Add drag scrolling functionality
			let isDown = false;
			let startX;
			let scrollLeft;

			$this.on('mousedown touchstart', function(e) {
				isDown = true;
				const clientX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
				startX = clientX - $this.offset().left;
				scrollLeft = $this.scrollLeft();
				$this.css('cursor', 'grabbing');
			});

			$this.on('mouseleave mouseup touchend', function() {
				isDown = false;
				$this.css('cursor', 'grab');
			});

			$this.on('mousemove touchmove', function(e) {
				if (!isDown) return;
				e.preventDefault();
				const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
				const x = clientX - $this.offset().left;
				const walk = (x - startX) * 2; // Adjust scroll speed
				$this.scrollLeft(scrollLeft - walk);
			});
		}
	});
}


